<h1 mat-dialog-title>
    <span [translate]="this.data?.ancienneClef == null ? 'admin.parametres.api.clef.creationClef' : 'admin.parametres.api.clef.modificationClef'"></span>
    <span [mat-dialog-close]><i class="zmdi zmdi-close"></i></span>
</h1>
<div mat-dialog-content>
    <form #form="ngForm">
        <div class="row">
            <custom-input
                    [(ngModel)]="exportClef.clef"
                    id="clef"
                    name="clef"
                    customType="input"
                    libelle="admin.parametres.api.clef.libelle"
                    [required]="true"
                    ngDefaultControl
                    [maxlength]="2000"
            ></custom-input>
        </div>

        <div class="row">
            <custom-input
                    [(ngModel)]="exportClef.valeur"
                    id="valeur"
                    name="valeur"
                    customType="input"
                    libelle="admin.parametres.api.clef.valeur"
                    [required]="true"
                    ngDefaultControl
                    [maxlength]="2000"
            ></custom-input>
        </div>

        <div class="d-flex flex-row-reverse">
            <button mat-flat-button color="primary"
                    (click)="onSubmit()"
                    [disabled]="form.invalid && !isUpdate">
                <span translate>global.actions.enregistrer</span>
            </button>
        </div>
    </form>
</div>
